<template>
  <v-dialog
    :model-value="modelValue"
    :scrim="scrim"
    persistent
    scrollable
    transition="dialog-bottom-transition"
    @update:model-value="emitUpdate"
  >
    <v-card class="success-modal">
      <v-card-title class="pa-5 flex-column v-header--fixed">
        <div class="d-flex justify-end" style="width: 100%">
          <v-btn icon variant="text" @click="closeModal">
            <icon height="14" width="14">close-x</icon>
          </v-btn>
        </div>
        <div>
          <icon
            class="d-block mx-auto mt-n4 mb-5"
            fill="rgb(var(--v-theme-success)), white"
            height="54"
            width="54"
          >
            check-mark-circle
          </icon>
          <h4 class="text-center mb-2">Email Sent!</h4>
        </div>
      </v-card-title>
      <v-card-text class="text-center body-1 pa-5 pt-0">
        Email Sent! Your request has been emailed to our support team. A
        representative will be in touch shortly.
      </v-card-text>
      <v-card-actions class="pa-5 flex-column">
        <v-btn
          color="primary"
          rounded="pill"
          size="large"
          variant="flat"
          width="100%"
          @click="closeModal"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'close-modal'],
  data() {
    return {
      scrim: 'rgba(0, 0, 0, 0.65)'
    };
  },
  methods: {
    emitUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    closeModal() {
      this.$emit('update:modelValue', false);
      this.$emit('close-modal');
    }
  }
};
</script>
